import encodeOpenCashDrawer from "./encodeOpenCashDrawer";
import encodeReceipt from "./encodeReceipt";

const ESCEncoder = {
  encodeOpenCashDrawer,
  encodeReceipt,
};

export default ESCEncoder;
